import { BuildedOrder, OrderFields } from '../../../../../baseComponents/TwinTable/types'
import { TwinDictionary } from '../../../../../utils/globals/dictionary'
import { OrderData } from '../types'

export const buildOrderFieldsOrderLayout = (orderFields: OrderFields) => {
    const buildedOrder: BuildedOrder = []
    for (const orderFieldKey in orderFields) {
        const orderFieldValue = orderFields[orderFieldKey]
        if (orderFieldValue !== null) {
            buildedOrder.push([orderFieldKey, orderFieldValue])
        }
    }
    return buildedOrder
}


export const groupTableDataByVariantParent = (tableData: OrderData['tableData']) => {
    const resultParsed = []
    if (tableData) {
        const tableDataCopy = JSON.parse(JSON.stringify(tableData))
        for (let key = 0; key < tableDataCopy.length; key++) {
            const element = tableDataCopy[key]
            if (element) {
                const OrderVariantGroupId = element['OrderVariantGroupId']
                if (OrderVariantGroupId) {
                    resultParsed.push({ reference: element['Product.Product.reference'], name: element['Product.Product.ProductLangs.name'], id: 'variantProduct_' + String(element['Product.Product.id']) + '_' + String(element.id), type: 'productCombinedHeader', FirstChildId: element.id, 'VariantGroupMainId': element['Product.Product.VariantGroupMainId'], OrderVariantGroupId: element['OrderVariantGroupId'], nLine: element.nLine, 'url': element['Product.Product.ProductImages.url'], ProductId: element['Product.Product.id'], 'Product.active': element['Product.active']})
                    resultParsed.push(element)
                    if (key < tableDataCopy.length - 1) {
                        for (let key2 = key+1; key2 < tableDataCopy.length; key2++) {
                            const element2 = tableDataCopy[key2]
                            if (element2['OrderVariantGroupId'] === OrderVariantGroupId) {
                                resultParsed.push(element2)
                                tableDataCopy.splice(key2, 1)
                                key2--
                            }
                        }
                    }
                } else {
                    resultParsed.push(element)
                }
            }
        }   
    }
    return [...resultParsed]
}
export const groupTableDataByAddonParent = (tableData: OrderData['tableData']) => {
    const resultParsed = []
    if (tableData) {
        const tableDataCopy = JSON.parse(JSON.stringify(tableData))
        for (let key = 0; key < tableDataCopy.length; key++) {
            const element = tableDataCopy[key]
            if (element) {
                const hasProductAddons = element['Product.hasComplements'] || element['Product.Product.hasComplements']
                const hasAddons = hasProductAddons || element['Product.hasCategoryComplements'] || element['Product.Product.hasCategoryComplements'] ? true : false
                const extraAddons = element['OrderAddonGroupId']
                if (hasAddons || extraAddons) {
                    resultParsed.push({ ...element, 'Product.hasComplements': hasProductAddons || false })
                    let position = resultParsed.length - 1
                    let hasChilds = false
                    if (key < tableDataCopy.length - 1) {
                        for (let key2 = key+1; key2 < tableDataCopy.length; key2++) {
                            const element2 = tableDataCopy[key2]
                            if (element.id === element2.OrderProductId) {
                                hasChilds = true
                                element2['Product.ProductId'] = element.ProductId
                                resultParsed.push(element2)
                                tableDataCopy.splice(key2, 1)
                                key2--
                            }
                        }
                    }
                    if (hasChilds) {
                        resultParsed[position].type = 'productCombinedHeaderAddon'
                    }
                } else {
                    resultParsed.push(element)
                }
            }
        }   
    }
    return [...resultParsed]
}

export const cleanTableDataForOriginalTable = (tableData: OrderData['tableData']) => {
    const result: OrderData['originalTableData'] = []
    const copy = JSON.parse(JSON.stringify(tableData))
    for (const element of copy) {
        if (element.ProductId) {
            result.push(element)
        }
    }
    return result
}
export const parseOrderTags = (headerData: OrderData['header']) => {
    const tagsSelected: string[] = []
    if(headerData.OrderTags){
        for (const tag of headerData.OrderTags) {
            tagsSelected.push(tag.id)
        }
    }
    return {...headerData, tags: tagsSelected}
}

export const addErrorsOfTableDataInHeader = (orderData: OrderData) => {
    const errors = []
    for (const element of orderData.originalTableData) {
        if (element.packQuantities && !element.packQuantity) {
            errors.push({element, errorToResolve: '__left_select_quantity'})
        }
    }
    orderData.header.errorsToResolve = errors
    return orderData
}
export const addInventPositionToOrderData = (orderData: OrderData) => {
    let position= 0
    for (const element of orderData.tableData) {
        element.inventPosition = position
        position++
    }
    return orderData
}

export const parseScalesOfOrderData = (orderData: OrderData) => {
    orderData.scaleByProduct = {}
    orderData.scaleByProductWeight = {}
    orderData.scaleByVariable = {}
    for (const key in orderData.tableData) {
        const element = orderData.tableData[key]
        parseScaleOrderDataSingle(orderData, element, parseInt(key))
    }
    return orderData
}

export const parseScaleOrderDataSingle = (orderData: TwinDictionary, element: TwinDictionary, key: number) => {
    if (element.OrderAddonGroupId) {
        if (element.ScaleOrderProductId) {
            if(element.scaleByWeight){
                if (!orderData.scaleByProductWeight?.[element.ScaleOrderProductId]) {
                    orderData.scaleByProductWeight[element.ScaleOrderProductId] = []
                }
                orderData.scaleByProductWeight[element.ScaleOrderProductId].push({ index: key, scaleQuantity: parseFloat(element.scaleQuantity) })
            } else {
                if (!orderData.scaleByProduct?.[element.ScaleOrderProductId]) {
                    orderData.scaleByProduct[element.ScaleOrderProductId] = []
                }
                orderData.scaleByProduct[element.ScaleOrderProductId].push({ index: key, scaleQuantity: parseFloat(element.scaleQuantity) })
            }
        } else if (element.ScaleVariableId) {
            if (!orderData.scaleByVariable?.[element.ScaleVariableId]) {
                orderData.scaleByVariable[element.ScaleVariableId] = []
            }
            orderData.scaleByVariable[element.ScaleVariableId].push({ index: key, scaleQuantity: parseFloat(element.scaleQuantity) })
        }
    }
}